(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["visitor-count-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('visitor-count-badge')) {
    class VisitorCountBadge extends HTMLElement {
      connectedCallback() {
        this.min = parseInt(this.dataset.min, 10) || 50;
        this.max = parseInt(this.dataset.max, 10) || 100;
        this.countEl = this.querySelector('[ref="count"]');

        this.value = this.#randomInt(this.min, this.max);
        this.#render();

        this.interval = setInterval(() => this.#drift(), this.#randomInt(1000, 3000));
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      #randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      #drift() {
        const step = this.#randomInt(1, 4) * (Math.random() < 0.5 ? -1 : 1);
        let next = this.value + step;
        if (next < this.min) next = this.min + Math.abs(step);
        if (next > this.max) next = this.max - Math.abs(step);
        this.value = Math.max(this.min, Math.min(this.max, next));
        this.#render();

        clearInterval(this.interval);
        this.interval = setInterval(() => this.#drift(), this.#randomInt(1000, 3000));
      }

      #render() {
        if (this.countEl) this.countEl.textContent = this.value;
      }
    }

    customElements.define('visitor-count-badge', VisitorCountBadge);
  }
  } catch(e) { console.error(e); }
})();

})();
